import * as React from "react";

function IcSystemStatusInfoFill12(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 12,
    height = 12,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemStatusInfoFill12"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#clip0_10389_5634)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12ZM5.75 2.75C5.33579 2.75 5 3.08579 5 3.5V4C5 4.41421 5.33579 4.75 5.75 4.75H6.25C6.66421 4.75 7 4.41421 7 4V3.5C7 3.08579 6.66421 2.75 6.25 2.75H5.75ZM6.75 6.5C6.75 6.08579 6.41421 5.75 6 5.75C5.58579 5.75 5.25 6.08579 5.25 6.5V8.5C5.25 8.91421 5.58579 9.25 6 9.25C6.41421 9.25 6.75 8.91421 6.75 8.5V6.5Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_10389_5634">
          <rect width={12} height={12} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IcSystemStatusInfoFill12;
